import { createSelector } from 'reselect';

import { getHeaderData } from '../../selectors';

export const getModifiedHeaderData = createSelector(getHeaderData, (headerData) => ({
  ...headerData,
}));

export const getMainSiteUrl = (state) => getHeaderData(state).mainSiteUrl || '';

const getHeaderLoginModel = (state) => getHeaderData(state).loginModel || {};
export const getBisLoginUrl = (state) => getHeaderLoginModel(state).bisLoginUrl || null;

const getCurrentAccount = (state) => getHeaderData(state).currentAccount || {};
export const getCurrentAccountCtn = (state) => getCurrentAccount(state).ctn || null;
export const getUserIsAuthenticated = (state) => !!getCurrentAccountCtn(state);
export const getHeaderRegionTitle = (state) =>
  ((getHeaderData(state).currentRegion || {}).userRegion || {}).title || '';
